import moment from 'moment';
import {getDocumentLang} from '../../js/main/utils';

export default function formatDate(value, format='MMMM D, YYYY') {
  if (!value) return '';

  let dateObject;
  if (typeof value === 'number') {
    dateObject = moment.unix(value);
  } else {
    dateObject = moment(value);
  }

  return dateObject.locale(getDocumentLang()).format(format);
}
